// src/components/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";

function ProtectedRoute({ children }) {
  // چک کن ببین کاربر لاگین کرده یا نه
  const isLoggedIn = localStorage.getItem("admin_logged_in") === "true";

  if (isLoggedIn) {
    return children; // اگر لاگین کرده، صفحه رو نشون بده
  } else {
    return <Navigate to="/login" replace />; // اگر نه، به لاگین بفرست
  }
}

export default ProtectedRoute;
